import React from 'react'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

export const TooltipPlacement = {
  top: 'top',
  bottom: 'bottom',
  left: 'left',
  right: 'right',
} as const

export type TooltipPlacement = (typeof TooltipPlacement)[keyof typeof TooltipPlacement]

const getTransform = (placement: TooltipPlacement, shift: number) => {
  switch (placement) {
    case 'top':
    case 'bottom':
      return `${shift}px 0`
    case 'left':
    case 'right':
    default:
      return `0 ${shift}px`
  }
}

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    footer?: React.ReactNode
    appearance?: 'light' | 'dark'
    placement?: TooltipPlacement
    shift?: number
    style?: React.CSSProperties
  }
>

const Tooltip = ({
  className,
  children,
  footer,
  placement = TooltipPlacement.top,
  shift = 0,
  appearance = 'light',
  style,
  ...props
}: Props) => (
  <div
    {...props}
    className={cn(
      'Tooltip',
      {[`placement-${placement}`]: true, [`appearance-${appearance}`]: true},
      className
    )}
    style={style}
  >
    <div className="Tooltip__main">
      <div className="Tooltip__content">{children}</div>
      {footer && <div className="Tooltip__footer">{footer}</div>}
    </div>
    <div
      className="Tooltip__arrow"
      aria-hidden
      style={{
        translate: getTransform(placement, shift),
      }}
    />
  </div>
)

export default Tooltip
